import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/index.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    meta: {
      title: '出口',
    },
  },
  {
    path: '/jieshunhome',
    name: 'jieshunHome',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/jieshunHome.vue'),
    meta: {
      title: '出口',
    },
  },
  {
    path: '/enter',
    name: 'Enter',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Enter.vue'),
    meta: {
      title: '入口',
    },
  },
  {
    path: '/jieshunenter',
    name: 'jieshunEnter',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/jieshunEnter.vue'),
    meta: {
      title: '入口',
    },
  },
  {
    path: '/unlicensed',
    name: 'unlicensed',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/unlicensed.vue'),
    meta: {
      title: '无牌',
    },
  },
  {
    path: '/jieshununlicensed',
    name: 'jieshununlicensed',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/jieshununlicensed.vue'),
    meta: {
      title: '无牌',
    },
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
